import { Directive, ElementRef, Inject, OnInit } from '@angular/core';
import { Theme, THEME_TOKEN } from '../types/theme.types';
import { inputStylesSAG, inputStylesSHS } from './input.styles';
import { componentStylesByTheme } from '../utils/theme.utils';
import { updateElementStyles } from '../utils/style.utils';

@Directive({
  selector: 'input[sag-ui-input],textarea[sag-ui-input]',
})
export class InputDirective implements OnInit {
  constructor(
    @Inject(THEME_TOKEN) private readonly theme: Theme,
    private readonly elementRef: ElementRef<HTMLInputElement>,
  ) {}

  ngOnInit(): void {
    const inputStyles = componentStylesByTheme(
      this.theme,
      inputStylesSAG,
      inputStylesSHS,
    );
    updateElementStyles(this.elementRef, inputStyles());
  }
}
